/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./upload-modular.vue?vue&type=template&id=861dcc52&scoped=true&"
import script from "./upload-modular.vue?vue&type=script&lang=ts&"
export * from "./upload-modular.vue?vue&type=script&lang=ts&"
import style0 from "./upload-modular.vue?vue&type=style&index=0&id=861dcc52&prod&lang=scss&scoped=true&"
import style1 from "./upload-modular.vue?vue&type=style&index=1&id=861dcc52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861dcc52",
  null
  
)

export default component.exports